import {Dialog, DialogTitle} from "@mui/material";

import "./style.css";

const CustomizedDialog = (props) => {
    const {open, title, showActionButton, closeBtnLabel, onClose, children} = props

    return <Dialog open={open}>
        <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold'}}>{title}</DialogTitle>
        <div className="dialog-body-container">
            {children}
            {showActionButton ? <div className="dialog-action-container">
                <button onClick={onClose}>{closeBtnLabel}</button>
            </div> : null}
        </div>
    </Dialog>
}

export default CustomizedDialog;